import { useEffect } from 'react'
import { useMatches } from 'react-router-dom'

interface RouteHandle {
	title?: string | ((params: Record<string, string | undefined>) => string)
}

export const usePageTitle = () => {
	const matches = useMatches()

	useEffect(() => {
		const matchWithTitle = matches
			.slice()
			.reverse()
			.find((match) => (match.handle as RouteHandle)?.title)

		if (!matchWithTitle) {
			document.title = 'viaPeople'
			return
		}

		const handle = matchWithTitle.handle as RouteHandle
		const titleConfig = handle.title

		let title: string
		if (typeof titleConfig === 'function') {
			title = titleConfig(matchWithTitle.params)
		} else {
			title = titleConfig || 'viaPeople'
		}

		document.title = title
	}, [matches])
}
